import { useRef as o, useState as s, useMemo as f, useEffect as a } from "react";
const m = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function l() {
  const t = o(0), e = o(null), [n, i] = s(m), r = f(() => typeof window < "u" ? new ResizeObserver((u) => {
    const c = u[0];
    c && (cancelAnimationFrame(t.current), t.current = requestAnimationFrame(() => {
      e.current && i(c.contentRect);
    }));
  }) : null, []);
  return a(() => (e.current && r.observe(e.current), () => {
    r.disconnect(), t.current && cancelAnimationFrame(t.current);
  }), [e.current]), [e, n];
}
function h() {
  const [t, { width: e, height: n }] = l();
  return { ref: t, width: e, height: n };
}
export {
  h as useElementSize,
  l as useResizeObserver
};
